const leftAlignStyle = {
  'text-align': 'left',
};
const centerAlignStyle = {
  'text-align': 'center',
};
const makeAlignStyle = {
  'border-left': '1px solid #808080',
  'text-align': 'left',
};

export const columnDefs = [
  {
    headerName: 'MAKE',
    field: 'make',
    width: 100,
    suppressSorting: true,
    suppressSizeToFit: true,
    suppressMenu: true,
    cellStyle: makeAlignStyle,
  },
  {
    headerName: 'MODEL',
    field: 'model',
    width: 90,
    suppressSorting: true,
    suppressSizeToFit: true,
    suppressMenu: true,
    cellStyle: leftAlignStyle,
  },
  {
    headerName: 'YEAR',
    field: 'year_string',
    width: 60,
    suppressSorting: true,
    suppressSizeToFit: true,
    suppressMenu: true,
    cellStyle: centerAlignStyle,
  },
  {
    headerName: 'STATE',
    field: 'state',
    width: 65,
    suppressSorting: true,
    suppressSizeToFit: true,
    suppressMenu: true,
    cellStyle: centerAlignStyle,
    cellRenderer: 'StateCellRenderer',
  },
  {
    headerName: 'FAILED COMPONENT',
    field: 'component',
    width: 200,
    suppressSorting: true,
    suppressSizeToFit: true,
    suppressMenu: true,
    cellStyle: centerAlignStyle,
  },
  {
    headerName: 'CRASH',
    field: 'crashed',
    width: 30,
    suppressSorting: true,
    suppressSizeToFit: true,
    suppressMenu: true,
    headerClass: 'crashed',
    cellStyle: centerAlignStyle,
    cellRenderer: 'DefaultMetricCellRenderer',
  },
  {
    headerName: 'FIRE',
    field: 'fire',
    width: 30,
    suppressSorting: true,
    suppressSizeToFit: true,
    suppressMenu: true,
    headerClass: 'fire',
    cellStyle: centerAlignStyle,
    cellRenderer: 'DefaultMetricCellRenderer',
  },
  {
    headerName: 'INJURY',
    field: 'injured',
    width: 30,
    suppressSorting: true,
    suppressSizeToFit: true,
    suppressMenu: true,
    headerClass: 'injured',
    cellStyle: centerAlignStyle,
    cellRenderer: 'DefaultMetricCellRenderer',
  },
  {
    headerName: 'MPH',
    field: 'speed',
    width: 40,
    suppressSorting: true,
    suppressSizeToFit: true,
    suppressMenu: true,
    headerClass: 'speed',
    cellStyle: centerAlignStyle,
    cellRenderer: 'SpeedCellRenderer',
  },
  {
    headerName: 'DESCRIPTION OF ISSUE',
    field: 'description',
    minWidth: 320,
    suppressSorting: true,
    suppressMenu: true,
    cellStyle: leftAlignStyle,
  },
];
